'use client';
import React from 'react';

import ErrorPageContainer from './ErrorPageContainer';
import { Container } from './styled';

const ErrorPage404 = () => {
  return (
    <Container>
      <ErrorPageContainer
        errorPageCode='/static/images/error/404.png'
        errorTextFirstLine='Hey! Kayboldun sanırım,'
        errorTextSecondLine='bazen kaybolmak da güzeldir!'
      />
    </Container>
  );
};
export default ErrorPage404;
